import { openModal } from 'actions/modal';
import { useThunkDispatch } from 'utils/reduxHook';

interface PlayHubVideoButtonProps {
  imageUrl: string;
}

function PlayVideoButton({ imageUrl }: PlayHubVideoButtonProps) {
  const dispatch = useThunkDispatch();

  const openVideo = () => {
    dispatch(openModal('Video', { url: imageUrl, disableDownload: true }));
  };

  return (
    <button
      onClick={openVideo}
      data-durable-id="play-video"
      data-intercom-target="play-video"
      className="absolute inset-0 m-auto flex items-center justify-center rounded-full bg-neutral-100/80 w-[100px] h-[100px]"
    >
      <div className="border-solid border-l-black border-l-8 border-y-transparent border-y-8 border-r-0 transform scale-150" />
    </button>
  );
}

export default PlayVideoButton;
